// extracted by mini-css-extract-plugin
export var circle = "languageToggle-module--circle--71feb";
export var language = "languageToggle-module--language--0cf1e";
export var languageToggle = "languageToggle-module--languageToggle--77fd7";
export var selected = "languageToggle-module--selected--14c48";